import ImageLoader from '../../ImageLoader';
import star from '../../../common/images/revamp/icon/star.svg';
import motorbike from '../../../common/images/revamp/icon/motorbike.svg';
import { checkHoldTime, checkTime, isEmptyData } from '../../../utils/helper';
import useNavigation from '../../../hook/useNavigation';
import { ClockIcon } from '@heroicons/react/24/solid';
import { PinPointIcon } from 'utils/svg';

const Card = (props) => {
  const navigate = useNavigation();

	const { item } = props;
	const distance = parseFloat(item?.distance || 0)?.toFixed('1');
  const isBusy = item?.endHold && checkHoldTime(item?.endHold);
  const outletStatus = isBusy ? `Resto sedang sibuk` : `Tutup${item?.outletOpenTime ? ` - Buka pukul ${item?.outletOpenTime} ${checkTime(item?.outletOpenTime)} hari ini` : ''}`;

	const handleClick = () => {
		if (item?.storeOpen === '1') {
			navigate.push({
				pathname: `/outlet/${item?.storeSlug}/delivery`,
				state: {
					storeID: item?.storeID,
					storeSlug: item?.storeSlug,
					storeName: item?.storeName,
					storeImage: item?.storeImage,
					rating: item?.rating,
					bannerImage: item?.storeBannerImage,
				},
			});
		}
	};

	return (
		<div className='w-32 h-full bg-white z-0 border border-solid border-gray-200 rounded-xl' onClick={handleClick}>
			<ImageLoader src={item?.storeImage} className='aspect-square h-32 w-32 rounded-xl object-cover object-center' />
			<div className='flex flex-col gap-2 p-2'>
        <div className={`${item?.storeOpen === '0' ? 'flex' : 'hidden'} items-center`}>
          <ClockIcon class='h-4 w-4 min-w-4 text-red-500 mr-1' />
          <div className='text-xxs font-normal text-gray-900'>{outletStatus}</div>
        </div>
        <div className={`${item?.outOfDelivery && item?.storeOpen === '1' ? 'flex' : 'hidden'} items-center`}>
          <PinPointIcon className={'stroke-red-500 text-red-500 fill-red-500 mr-1 h-3 w-3 min-w-3'} />
          <div className='text-xs font-normal text-orange-700'>Diluar Jangkauan Pengiriman</div>
        </div>
        <div className='flex gap-1 items-center !mt-0'>
					<div className={`${isEmptyData(item?.rating) ? 'hidden' : 'flex'}  items-center gap-1`}>
						<img src={star} alt='star' />
						<span className='font-semibold text-xxs text-[var(--dark-gray)]'>
							{item?.rating || 0} ({item?.totalRating || 0})
						</span>
					</div>
				</div>
				<p className={`line-clamp-2 font-semibold text-xs cursor-pointer text-gray-700`}>{item?.storeName}</p>
				<div className='flex items-center gap-1'>
					<img src={motorbike} alt='motorbike' />
					<span className='text-xxs'>{distance} km</span>
				</div>
			</div>
		</div>
	);
};

export default Card;
